import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Empresa } from '../_models/usuario/empresa';
import { Observable } from 'rxjs';
import { EmpresaResponse } from '../_models/response/empresaResponse';
import { Usuario } from '../_models/usuario/usuario';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class EmpresaService {
  constructor(private http: HttpClient) { }


  getEmpresasPorUsuario(usuario: Usuario): Observable<Empresa[]> {
    return this.http.post<Empresa[]>(`${environment.authorizedUrls.bsCobrancaUrl}/empresa/listarEmpresaPorUsuario`,
    {usuario} );
  }

  inserir(empresa: Empresa): Observable<EmpresaResponse> {
    return this.http.post<EmpresaResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/empresa/incluir`, {
      empresa
    });
  }

  atualizar(empresa: Empresa): Observable<EmpresaResponse> {
     return this.http.post<EmpresaResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/empresa/atualizar`, {
      empresa
    });
  }

  deletar(empresa: Empresa) {
    return this.http.post<EmpresaResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/empresa/excluir`, {
      empresa
    });
  }
}
